/* This file is autogenerated, see readme.md for instructions */
import ClockCircleSvgIcon from '@bloomreach/banana-theme/icons/clock-circle.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ClockCircleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ClockCircleSvgIcon />
    </Icon>
  );
});

ClockCircleIcon.displayName = 'ClockCircleIcon';

export default ClockCircleIcon;
